import SAPOMailConfig from '@/SAPOMailConfig';
import { reactive } from 'vue';
import BroadcastEventManager from '../Shared/Events/Managers/BroadcastEventManager';
import VersionItem from './Entities/VersionItem';

export { VersionControllerSingleton as default };

/**
* Control versions between backend and frontend
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class VersionController {
  /**
   * VersionItem
   *
   * @public
   *
   * @type {VersionItem}
   *
   * @since 7.0.0
   */
  data = new VersionItem;

  /**
   * Name of the event that can be used in the broadcaster
   * to listen when there are changes in versions of the
   * JS for the Server
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   *
   * @default PTMAIL-NEW-VERSION
   */
  static VERSION_EVENT_NAME = 'PTMAIL-NEW-VERSION';

  /**
   * Parameter that is returned in the response headers
   * of requests
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   *
   * @default X-PTMAIL-VERSION
   */
  static VERSION_HEADER_NAME = 'X-PTMAIL-VERSION';

  /**
   * BroadcastEventManager
   *
   * @public
   *
   * @type {BroadcastEventManager}
   *
   * @since 7.0.0
   */
  broadcaster = new BroadcastEventManager;

  constructor(){
    this.data.version.js = SAPOMailConfig.client.version.js;
  }

  /**
   * Identifies the version that is passed via header
   * responses to requests to the server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Headers} headers
   *
   * @returns {void}
   */
  requestHeaderVersion(headers){
    let header = headers.get(VersionController.VERSION_HEADER_NAME);

    if(!header || header === this.data.version.js){
      return;
    }

    this.setIsWarningVisbile(true);
    this.broadcaster.broadcast(VersionController.VERSION_EVENT_NAME, {
      request_header_version: headers.get(VersionController.VERSION_HEADER_NAME)
    });
  }

  /**
   * Set var is_warning_visible in
   * Entity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Boolean} value
   *
   * @returns {void}
   */
  setIsWarningVisbile(value){
    this.data.is_waning_visible = value;
  }
}

const VersionControllerSingleton = reactive(new VersionController);